import React from 'react';
import { SyncOutlined } from '@ant-design/icons';
import BukkuTooltip from '../../Tooltip';

export default function SyncedIcon() {
    return (
        <BukkuTooltip title="Synced">
            <SyncOutlined color="blue" />
        </BukkuTooltip>
    );
}
